import React, { useEffect, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';
function getToggleStyle(height, timeout, show) {
    return {
        entering: {
            transition: `height ${timeout}ms ease-in`,
            height: `${height}px`
        },
        entered: {
            height: show ? 'auto' : `${height}px`
        },
        exiting: {
            transition: `height ${timeout}ms ease-in`,
            height: `0`,
        },
        exited: {
            height: '0'
        }
    };
}
const SaleAccordion = ({ children, show }) => {
    const mainEl = useRef(null);
    const toggleTimeout = 500;
    const [toggle, setToggle] = useState(true);
    const [toggleStyle, setToggleStyle] = useState({});
    // Showプロパティの切り替え
    useEffect(() => {
        if (mainEl.current === null) {
            return;
        }
        const areaHeight = mainEl.current?.clientHeight;
        // 高さが0の場合は中身の要素が未生成
        if (areaHeight === 0) {
            return;
        }
        // トグル用のスタイルを更新する
        setToggleStyle(getToggleStyle(areaHeight, toggleTimeout, show));
        // 更新したtoggleStyleが反映されるまで切り替えを遅延させる
        setTimeout(() => setToggle(show), 10);
    }, [
        show,
        mainEl
    ]);
    return (React.createElement(Transition, { in: toggle, timeout: toggleTimeout }, state => (React.createElement("div", { className: "a-sale-accordion", style: toggleStyle[state] },
        React.createElement("div", { className: "a-sale-accordion-main", ref: mainEl }, children)))));
};
export default SaleAccordion;
